import React, { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { TableContext } from "../index";
import { Pagination } from "./Pagination";
import * as urlService from "./urlService";

//TODO add page size select
const PAGE_SIZE = 10;

/**
 * Retrieves data from the server and manages pagination.
 * Use only in TableContext scope.
 *
 * @param getPage - pagination request function
 * @param blocked - flag which stops data fetching
 */

export function PaginationManager({ getPage, blocked, sizeLimit = PAGE_SIZE }) {

    const history = useHistory();
    const location = useLocation();
    const { config, setConfig } = useContext(TableContext);
    const { lastUpdated } = config;

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);

    const onPageChange = (value) => {
        history.push(
            {
                pathname: history.location.pathname,
                search: urlService.updatePagination(value, sizeLimit)
            }
        )
    }

    useEffect(() => {

        if (blocked) {
            return;
        }

        const pagination = urlService.getPagination(true);
        const requestedPage = Number(pagination.page);
        const requestedSize = Number(pagination.size);
        const pageToLoad = Number.isFinite(requestedPage) && requestedPage >= 0 ? requestedPage : 0;
        const pageSize = Number.isFinite(requestedSize) && requestedSize > 0 ? requestedSize : sizeLimit;

        setCurrentPage(pageToLoad);

        setConfig(prev => ({
            ...prev,
            isLoading: true
        }));

        getPage(pageToLoad, pageSize).then((data) => {
            setTotalPages(data.totalPages);
            setTotalRecords(data.totalRecords);
            setConfig(prev => ({
                ...prev,
                devices: data.devices,
                pageNumber: data.pageNumber,
                totalPages: data.totalPages,
                selectAll: false,
                selected: [],
                hardReload: false,
                isLoading: false,
                loadError: data.error || null,
            }))
        }).catch((error) => {
            setTotalPages(0);
            setTotalRecords(0);
            setConfig(prev => ({
                ...prev,
                totalPages: 0,
                selectAll: false,
                selected: [],
                hardReload: false,
                isLoading: false,
                loadError: error?.message || 'Unable to load data',
            }))
        });
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [lastUpdated, location.search, blocked])

    return (
        <>
            <Pagination key={totalPages}
                total={totalPages}
                current={currentPage}
                totalRecords={totalRecords}
                onClick={(value) => onPageChange(value)} />
        </>
    )
}

export default PaginationManager;
